module.exports = "/static/media/nucleus-app-icon-n-reversed-vibrant-192.631d9582.png";